// extracted by css-extract-rspack-plugin
var _1 = "days-Bgj1sY";
var _2 = "times-Mq_hJM";
export { _1 as "days", _2 as "times" }
